import { styled } from "../../../styled-components";
import Img from "../img/img";

export const Style = styled.div`
    height: ${p => p.theme.map.defaultHeight}px;
    width: 100%;

    position: relative;
`;

export const MapImg = styled(Img)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
